import { render, staticRenderFns } from "./about-you.vue?vue&type=template&id=0639b818&scoped=true"
import script from "./about-you.vue?vue&type=script&lang=js"
export * from "./about-you.vue?vue&type=script&lang=js"
import style0 from "./about-you.vue?vue&type=style&index=0&id=0639b818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639b818",
  null
  
)

export default component.exports